import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Chat/JsonRenderComponents/signalCards/AssetKdjGaugeCard";
/**
 * ④ KDJ 仪表卡。 Figma：94542:227057
 */

import { cn } from "utils";

import { RsiGaugeBar } from "./miniCharts/RsiGaugeBar";
import { SignalCardShell } from "./SignalCardShell";
import type { RsiStatusTone, SignalCardAssetProps } from "./types";

const I18n = I18nUtil.createScoped(Translations);

export interface AssetKdjGaugeCardProps extends SignalCardAssetProps {
  kdjValue: number;
  /** Optional marker position (0–100); defaults to `kdjValue` */
  indicatorPosition?: number;
  statusTone?: RsiStatusTone;
}

const STATUS_LABEL: Record<RsiStatusTone, string> = {
  overbought: "overbought",
  oversold: "oversold",
  neutral: "neutral",
};

const resolveStatusTone = (
  kdjValue: number,
  statusTone?: RsiStatusTone,
): RsiStatusTone => {
  if (statusTone) {
    return statusTone;
  }
  if (kdjValue >= 70) {
    return "overbought";
  }
  if (kdjValue <= 30) {
    return "oversold";
  }
  return "neutral";
};

export const AssetKdjGaugeCard: React.FC<AssetKdjGaugeCardProps> = ({
  kdjValue,
  indicatorPosition,
  statusTone,
  ...asset
}) => {
  const tone = resolveStatusTone(kdjValue, statusTone);
  const toneClass =
    tone === "overbought"
      ? "text-content_accent2_primary"
      : tone === "oversold"
        ? "text-content_accent1_primary"
        : "text-content_primary";

  return (
    <SignalCardShell {...asset}>
      <div className="flex items-center justify-between gap-3">
        <div className={cn("flex flex-col gap-1", toneClass)}>
          <p className="headline_regular_l">
            {I18n.t("KDJ")}
            {kdjValue}
          </p>
          <p className="body_medium_m">{STATUS_LABEL[tone]}</p>
        </div>
        <RsiGaugeBar
          rsiValue={kdjValue}
          indicatorPosition={indicatorPosition}
          gaugeLabel="KDJ"
        />
      </div>
    </SignalCardShell>
  );
};
